import {Component, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../../../../translation/Services/language.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';

import {concat, Observable, of, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap} from 'rxjs/operators';
import {Language} from '../../../Models/Languge';

@Component({
  selector: 'app-manage-language',
  templateUrl: './manage-language.component.html',
  styleUrls: ['./manage-language.component.scss']
})
export class ManageLanguageComponent implements OnInit {
  public languageId;
  public classicBox;
  public enableSave = false;
  public language: Language = new Language();
  public languages: Observable<Language[]>;
  public languageLoading = false;
  public languagesinput$ = new Subject<string>();
  public selectedLanguage: Language;
  public lastValue = {language: new Language()};
  public isEdit = false;
  @ViewChild('classicForm', {static: false}) child;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private languageService: LanguageService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.loadLanguage();
    this.route.params.subscribe(params => {
      new Promise((resolve) => {
        if (Helper.isDefined(params['id'])) {
          this.languageId = params['id'];
          this.isEdit = true;
          this.languageService.getLanguageById(this.languageId).subscribe(resp => {
            this.languageId = resp.language.id;
            resolve(resp.language);
          });
        } else {
          resolve(new Language());
        }
      }).then(language => {
          this.lastValue = {language: (<Language>language)};
          this.classicBox = <FormlyFieldConfig>[
            {
              fieldGroupClassName: 'row',
              key: 'language',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'name',
                  templateOptions: {
                    label: this.translate.instant('doctrine.language.name'),
                    required: true,
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                        {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'locale',
                  templateOptions: {
                    label: this.translate.instant('doctrine.language.locale'),
                    required: true,
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                        {limit: field.templateOptions.maxLength})
                    },
                  },
                },
              ],
            },
          ];
        }
      );
    });
  }

  submitItem(next: boolean) {
    if (next) {
      this.languageService.manageLanguage(
        {name: this.lastValue.language.name, locale: this.lastValue.language.locale},
        this.isEdit,
        this.languageId
      ).subscribe(() => {
        this.router.navigateByUrl('/back-office/localization/languages');
      });
    } else {
      this.router.navigateByUrl('/back-office/localization/languages');
    }
  }

  private loadLanguage() {
    const params = new HttpParams();
    this.languages = concat(
      of([]), // default items
      this.languagesinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter(query => query && query.length > 0),
        tap(() => this.languageLoading = true),
        switchMap((term) => this.languageService.getLanguageReplace(params.set('query', term)).pipe(
          catchError(() => of([])), // empty list on error
          tap((res) => {
            this.languageLoading = false;
          })
        ))
      )
    );
  }

  enableButton(event) {
    this.enableSave = event;
  }

  showDeleteModal() {
    this.deleteModal.show();
  }

  softDelete() {
    this.languageService.replaceLanguage(this.languageId, this.selectedLanguage.id).subscribe( res => {
      if (res) {
        this.deleteModal.hide();
        this.router.navigateByUrl('/back-office/localization/languages');
      }
    });
  }
}
